import { ActionTree } from "vuex";
import { TradeContractState, TradeContract } from "./model";
import { RootStateType } from "@/store";
import { AxiosResponse } from "axios";
import Qs from "qs";

const actions: ActionTree<TradeContractState, RootStateType> = {
  findList({ rootGetters, commit }, params) {
    const paramsHash = {
      params: params,
      paramsSerializer: function (params: object) {
        return Qs.stringify(params, { arrayFormat: 'brackets', skipNulls: true })
      }
    }

    return rootGetters['hcs/client'].get('/trade_contracts', paramsHash)
      .then((response: AxiosResponse) => {
        const tradeContracts: TradeContract[] = response.data;

        switch(params['statusEq']) {
          case 'requesting':
            commit('setRequestingTradeContracts', tradeContracts)
            break;
          case 'trading':
            commit('setTradingTradeContracts', tradeContracts)
            break;
        }

        return tradeContracts
      })
  },
  find({ rootGetters, commit }, id) {
    return rootGetters['hcs/client'].get(`/trade_contracts/${id}`)
      .then((response: AxiosResponse) => {
        const tradeContract: TradeContract = response.data;
        commit('setTradeContract', tradeContract)
        return tradeContract
      })
  },
  create({ rootGetters, dispatch }, params) {
    return rootGetters['hcs/client'].post('/trade_contracts', params)
      .then((response: AxiosResponse) => {
        dispatch('findList', { statusEq: 'requesting' })
      })
  },
  delete({ rootGetters, commit }, id) {
    return rootGetters['hcs/client'].delete(`/trade_contracts/${id}`)
        .then((response: AxiosResponse) => {
          commit('deleteRequestingTradeContracts', id)
        })
  },
  accept({ rootGetters, dispatch }, params) {
    return rootGetters['hcs/client'].patch(`/trade_contracts/${params.id}/accept`, params)
      .then((response: AxiosResponse) => {
        return Promise.all([
          dispatch('findList', { statusEq: 'requesting' }),
          dispatch('findList', { statusEq: 'trading' })
        ])
      })
  },
  reject({ rootGetters, dispatch }, params) {
    return rootGetters['hcs/client'].patch(`/trade_contracts/${params.id}/reject`, params)
      .then((response: AxiosResponse) => {
        return Promise.all([
          dispatch('findList', { statusEq: 'requesting' }),
          dispatch('findList', { statusEq: 'trading' })
        ])
      })
  },
  findResultList({ rootGetters, commit }, params) {
    return rootGetters['hcs/client'].get('/trade_contracts/results', {params})
      .then((response: AxiosResponse) => {
        const tradeContracts: TradeContract[] = response.data;
        commit('setTradingTradeContracts', tradeContracts)
        return tradeContracts;
      })
  },
}

export default actions;
